var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resGray lighten-6"},[(_vm.reconciliationsActive)?_c('reconciliations',{on:{"openCyclePage":_vm.openAddReconciliationPage}}):_vm._e(),(_vm.addReconciliationActive)?_c('add-reconciliation',{attrs:{"poolInfo":_vm.poolInfo},on:{"openPoolsPage":_vm.openPoolsPage}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }